import React from 'react';
import { CheckCircle, ArrowLeft } from 'lucide-react';

interface SurveyConfirmationProps {
  message: string;
  confirmationData?: any;
  primaryColor: string;
  onBackToEvent: () => void;
}

export const SurveyConfirmation: React.FC<SurveyConfirmationProps> = ({
  message,
  confirmationData,
  primaryColor,
  onBackToEvent,
}) => {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div
            className="h-2"
            style={{ backgroundColor: primaryColor }}
          />
          <div className="p-8 text-center">
            <div
              className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
              style={{ backgroundColor: `${primaryColor}20` }}
            >
              <CheckCircle
                size={40}
                style={{ color: primaryColor }}
              />
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              {message}
            </h2>

            <p className="text-gray-600 mb-8">
              Your responses have been successfully recorded. Thank you for taking the time to share your feedback.
            </p>

            <button
              onClick={onBackToEvent}
              className="inline-flex items-center px-6 py-3 text-white font-medium rounded-lg transition-colors"
              style={{ backgroundColor: primaryColor }}
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              Back to Event
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};